const localeAliases = {
  tw: 'tw',
  'zh-tw': 'tw',
  zh_tw: 'tw',
  'zh-hant': 'tw',
  'zh-hant-tw': 'tw',
  cn: 'cn',
  'zh-cn': 'cn',
  zh_cn: 'cn',
  'zh-hans': 'cn',
  'zh-hans-cn': 'cn',
  en: 'en',
  'en-us': 'en',
  en_us: 'en',
  us_en: 'en'
}

export function normalizeLocale (locale) {
  if (!locale) return 'tw'

  const key = String(locale).toLowerCase()
  return localeAliases[key] || 'tw'
}

export function getStoredLocale () {
  return normalizeLocale(window.localStorage.getItem('locale'))
}

export function syncStoredLocale () {
  const locale = getStoredLocale()
  window.localStorage.setItem('locale', locale)
  return locale
}
